angular.module('bribac.components.externalMonitorDetails', [])

  .component('externalMonitorDetails', {
    templateUrl: 'external-monitor-details-component.html',
    controller: 'ExternalMonitorDetailsCtrl',
    bindings: {
      externalMonitor: '<'
    }
  })

  .controller('ExternalMonitorDetailsCtrl', function(
    state
  ) {
    this.state = state
  })
